module.exports = __webpack_public_path__ + "static/img/eye_blue.9a8e2c1c.gif";